import styled from "styled-components";
import { Color, Opacity } from "../../../utils/style";
import { Icons } from "../../../utils/react-svg";

const Wrapper = styled.div`
  margin-right: 16px;
  display: inline-block;
`;

const Button = styled.button`
  color: ${Color.ritualBlue};
  font-weight: 500;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 4px;

  padding: 0;
  margin: 0;

  background: none;
  border: none;

  &:hover {
    opacity: ${Opacity.light};
  }

  transition: opacity 0.2s;

  [data-whatintent="mouse"] &:focus,
  [data-whatintent="touch"] &:focus {
    outline: none;
  }

  svg {
    height: 10px;
    width: auto;
    display: block;
    flex-shrink: 0;
  }

  svg path#y,
  svg path.st1 {
    fill: ${Color.ritualBlue};
  }
`;

const DoNotTrack = () => {
  const handleClick = () => {
    if (typeof window !== "undefined") {
      window?.DG_BANNER_API?.showConsentBanner();
    }
  };

  return (
    <Wrapper>
      <Button onClick={handleClick} aria-label="Cookie Preferences">
        <Icons.PrivacyOptions />
        Your Privacy Choices
      </Button>
    </Wrapper>
  );
};

export default DoNotTrack;
